<template>
  <el-form :model="form" :rules="rules">
    <p class="text-red-600 text-sm pb-2">
      请下载模板，并填写设备信息后导入数据，需要填写列不能为空，为空请用符号/代替，上传文件最大限制10MB。
    </p>
    <el-form-item>
      <el-button @click="handleDownTemplate">下载模板</el-button>
      <el-button @click="handleImport">导入数据</el-button>
    </el-form-item>

    <el-table :data="form.list">
      <el-table-column align="center" label="序号" type="index" />
      <el-table-column align="center" label="车间名称" prop="plant" />
      <el-table-column align="center" label="产线名称" prop="line" />
      <el-table-column align="center" label="设备编号" prop="code" />
      <el-table-column align="center" label="设备名称" prop="name" />
      <el-table-column align="center" label="设备分类" prop="type" />
      <el-table-column align="center" label="规格/型号" prop="size" />
      <el-table-column align="center" label="品牌/厂商" prop="factory" />
      <el-table-column align="center" label="入场日期" prop="date" />
      <el-table-column align="center" label="设备状态" prop="status" />
      <el-table-column align="center" label="是否已联网" prop="online" />
      <el-table-column align="center" label="是否已数控化" prop="digit" />
      <el-table-column align="center" label="是否已实时采集数据" prop="real" />
      <el-table-column align="center" label="保养周期（日）" prop="during" />
      <el-table-column align="center" label="上次保养的日期" prop="last" />
    </el-table>
  </el-form>
</template>

<script>
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";

export default {
  props: ["ans", "cb"],
  data() {
    return {
      form: {
        list: [],
        all: 0,
        digit: 0,
        online: 0,
        digitRate: 0,
        onlineRate: 0,
      },
      fileInfo: {},
      rules: {
        list: { required: true, message: "请导入设备清单", trigger: "blur" },
      },
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  mounted() {
    const list = this.ans.list || [];
    const all = this.ans.all || 0;
    const digit = this.ans.digit || 0;
    const online = this.ans.online || 0;
    const digitRate = this.ans.digitRate || 0;
    const onlineRate = this.ans.onlineRate || 0;
    Object.assign(this.form, {
      list,
      all,
      digit,
      online,
      digitRate,
      onlineRate,
    });
  },
  methods: {
    handleDownTemplate() {
      const a = document.createElement("a");
      a.href = "/buckets/static_files/equipment-template.xlsx";
      a.download = "设备清单模板.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleImport() {
      const dom = document.createElement("input");
      dom.type = "file";
      dom.style.display = "none";
      dom.accept = ".xlsx";
      document.body.appendChild(dom);
      dom.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error("上传文件大小不能超过 10MB!");
          return false;
        }

        const formData = new FormData();
        formData.append("file", file);

        Promise.all([
          fetch("/dev/minio", {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
            body: formData,
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.code !== 200) {
                this.$message.error(data.message || "未知错误，请销后再试！");
                return;
              }
              this.fileInfo = data.data;
            })
            .catch((err) => {
              this.$message.error("上传失败,请销后再试");
            }),
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              const workbook = XLSX.read(e.target.result, { type: "buffer" });
              const worksheet = workbook.Sheets[workbook.SheetNames[0]];
              const jsonData = XLSX.utils
                .sheet_to_json(worksheet, { header: 0, raw: false })
                .slice(1)
                .map((v) => Object.values(v));
              const all = jsonData.filter((v) => v[4]);
              const digit = all.filter((v) => v[11] === "是");
              const online = all.filter((v) => v[10] === "是");
              this.form.list = jsonData.map((v) => ({
                plant: v[1],
                line: v[2],
                code: v[3],
                name: v[4],
                type: v[5],
                size: v[6],
                factory: v[7],
                date: v[8],
                status: v[9],
                online: v[10],
                digit: v[11],
                real: v[12],
                during: v[13],
                last: v[14],
              }));
              this.form.all = all.length;
              this.form.digit = digit.length;
              this.form.online = online.length;
              this.form.digitRate = (
                (this.form.digit / (this.form.all || 1)) *
                100
              ).toFixed(2);
              this.form.onlineRate = (
                (this.form.online / (this.form.all || 1)) *
                100
              ).toFixed(2);
              resolve();
            };
            reader.readAsArrayBuffer(file);
          }),
        ]).then(() => {
          this.cb(this.form, this.fileInfo);
        });
      });
      dom.click();
    },
  },
};
</script>
